<template>
  <div class="blog-submenu-wrapper" :class="[{'search-shown' : showSearch}]">
    <div class="blog-submenu-parent" >

      <nav class="blog-submenu">
        <div class="blog-logo" >
          <a href="/" class="s-text-router-link s-flex s-tooltip" data-tooltip="Go to Seedr">
            <img :src="logoSvgImg" alt="Logo" class="blog-logo-icon " >
          </a>
          <a href="/pulse" class="s-text-router-link s-flex s-margin-r-auto s-tooltip" data-tooltip="Blog Home">
            <h1 class="blog-title">Blog</h1>
          </a>
        </div>

        <a href="/pulse/list" class="blog-nav-link"
           :class="[{'active': pageContext.urlPathname === '/pulse/list'}]">
          Latest
        </a>

        <div class="s-dropdown-parent s-dropdown-blog blog-nav-link s-margin-r-auto"
             :class="[
       {'active': pageContext.urlPathname.includes('/pulse/categories')},
       {'dropdown-mobile-open': isMobileDropdownOpen}
     ]">
          <a class="s-hide-tablet" href="/pulse/categories">Categories
            <s-icon class="s-hide-tablet" icon-font="s-icon-expand-line"/>
          </a>
          <a class="s-show-tablet" @click="isMobileDropdownOpen = !isMobileDropdownOpen">Categories</a>
          <div class="s-dropdown-child">
            <div class="s-dropdown-items">
              <a href="/pulse/categories"
                 class="dropdown-categories-explore"
                 :class="[{'selected': pageContext.urlPathname === '/pulse/categories'}]"
                 @click="isMobileDropdownOpen = false">
                explore <s-icon :icon-image="iconExploreImg" />
              </a>

              <a v-for="category in categories"
                 :key="category.slug"
                 :href="`/pulse/categories/${category.slug}`"
                 :class="[{'selected': pageContext.urlPathname === `/pulse/categories/${category.slug}`}]"
                 @click="isMobileDropdownOpen = false"
              >
                {{ category.name }}
              </a>
            </div>
          </div>
        </div>
        <span class="search " @click="toggleSearch">
        <s-icon class="s-hvr-circle-blue" icon-font="s-icon-search" circle tooltip="Search in Blog"/>
      </span>

        <BlogSearch v-if="showSearch" @close-search="toggleSearch"/>
      </nav>
    </div>
  </div>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue'
import { usePageContext } from 'vike-vue/usePageContext'
import { useData } from 'vike-vue/useData'
import SIcon from '/components/SIcon.vue'
import BlogSearch from "#root/components/BlogSearch.vue"
import logoSvgImg from "/assets/images/Logo_SVG.svg?url"
import {getAllCategories} from "#root/services/contentService";

import iconExplore from '/assets/images/icon_explore.svg?url'


const showSearch = ref(false)
const pageContext = usePageContext()
const categories = ref([])
const { article, tags } = useData()

const iconExploreImg = ref(iconExplore)

const isMobileDropdownOpen = ref(false)


// Compute current category
const currentCategory = computed(() => {
  const categorySlug = pageContext.routeParams?.category

  if (categorySlug) {
    return categories?.value?.find(cat => cat.slug === categorySlug)
  }

  if (article?.value?.category) {
    return {
      name: article.value.category,
      slug: article.value.categorySlug
    }
  }

  return null
})

// Compute current tag
const currentTag = computed(() => {
  const tagSlug = pageContext.routeParams?.tag

  if (tagSlug) {
    return tags?.value?.find(tag => tag.slug === tagSlug)
  }

  return null
})

// Search handlers
const toggleSearch = () => {
  showSearch.value = !showSearch.value
  if (typeof document !== 'undefined') {
    if (showSearch.value) {
      document.addEventListener('keydown', handleEsc)
    } else {
      document.removeEventListener('keydown', handleEsc)
    }
  }
}

const handleEsc = (event) => {
  if (event.key === 'Escape') {
    showSearch.value = false
    if (typeof document !== 'undefined') {
      document.removeEventListener('keydown', handleEsc)
    }
  }
}

// Initialize keyboard shortcuts
if (typeof document !== 'undefined') {
  const handleCtrlF = (event) => {
    if (event.ctrlKey && event.key === 'f') {
      event.preventDefault()
      if (!showSearch.value) {
        toggleSearch()
      }
    }
  }
  document.addEventListener('keydown', handleCtrlF)
}



onMounted(async () => {
  try {
    categories.value = await getAllCategories()
  } catch (err) {
    console.error('Error fetching categories:', err)
  }
})
</script>


